import { FetchHttpRequest } from './core/FetchHttpRequest';
import { AiConversationsService } from './services/AiConversationsService';
import { ApiKeysService } from './services/ApiKeysService';
import { ApiMonitoringService } from './services/ApiMonitoringService';
import { BranchesService } from './services/BranchesService';
import { CodeCompletionsService } from './services/CodeCompletionsService';
import { CredentialsService } from './services/CredentialsService';
import { DeviceLoginService } from './services/DeviceLoginService';
import { EntitlementsService } from './services/EntitlementsService';
import { EnvironmentVariablesService } from './services/EnvironmentVariablesService';
import { FeedbackService } from './services/FeedbackService';
import { GitService } from './services/GitService';
import { HealthService } from './services/HealthService';
import { HomepageService } from './services/HomepageService';
import { IdentitiesService } from './services/IdentitiesService';
import { IdentityDomainsService } from './services/IdentityDomainsService';
import { IdentityProvidersService } from './services/IdentityProvidersService';
import { InvitesService } from './services/InvitesService';
import { LinkChecksService } from './services/LinkChecksService';
import { MembershipsService } from './services/MembershipsService';
import { NomadEventsService } from './services/NomadEventsService';
import { OrganizationsService } from './services/OrganizationsService';
import { OrganizationSlugsService } from './services/OrganizationSlugsService';
import { ProjectAnalyticsService } from './services/ProjectAnalyticsService';
import { ProjectBuildsService } from './services/ProjectBuildsService';
import { ProjectCustomDomainsService } from './services/ProjectCustomDomainsService';
import { ProjectDeploysService } from './services/ProjectDeploysService';
import { ProjectsService } from './services/ProjectsService';
import { ProjectSlugsService } from './services/ProjectSlugsService';
import { ProjectSourcesService } from './services/ProjectSourcesService';
import { ProjectTemplatesService } from './services/ProjectTemplatesService';
import { PullRequestsService } from './services/PullRequestsService';
import { PushesService } from './services/PushesService';
import { QueuesService } from './services/QueuesService';
import { RbacService } from './services/RbacService';
import { RegistryService } from './services/RegistryService';
import { RemotesService } from './services/RemotesService';
import { ScorecardsService } from './services/ScorecardsService';
import { ScoutService } from './services/ScoutService';
import { SeatsService } from './services/SeatsService';
import { SessionService } from './services/SessionService';
import { SlackService } from './services/SlackService';
import { SubscriptionService } from './services/SubscriptionService';
import { SupportService } from './services/SupportService';
import { SyncerService } from './services/SyncerService';
import { TeamsService } from './services/TeamsService';
import { UserInvitesService } from './services/UserInvitesService';
import { UsersService } from './services/UsersService';
import { WysiwygService } from './services/WysiwygService';
export class Client {
    constructor(config, interceptor) {
        var _a, _b, _c, _d;
        Object.defineProperty(this, "aiConversations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "apiKeys", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "apiMonitoring", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "branches", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "codeCompletions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "credentials", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "deviceLogin", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "entitlements", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "environmentVariables", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "feedback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "git", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "health", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "homepage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "identities", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "identityDomains", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "identityProviders", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "invites", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "linkChecks", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "memberships", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "nomadEvents", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "organizations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "organizationSlugs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "projectAnalytics", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "projectBuilds", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "projectCustomDomains", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "projectDeploys", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "projects", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "projectSlugs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "projectSources", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "projectTemplates", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "pullRequests", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "pushes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "queues", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "rbac", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "registry", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "remotes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "scorecards", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "scout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "seats", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "session", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "slack", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "subscription", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "support", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "syncer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "teams", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "userInvites", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "users", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "wysiwyg", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "request", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "interceptor", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.interceptor = interceptor;
        this.request = new FetchHttpRequest({
            BASE: (_a = config === null || config === void 0 ? void 0 : config.BASE) !== null && _a !== void 0 ? _a : 'https://app.blueharvest.cloud/api',
            VERSION: (_b = config === null || config === void 0 ? void 0 : config.VERSION) !== null && _b !== void 0 ? _b : '1.0.1',
            WITH_CREDENTIALS: (_c = config === null || config === void 0 ? void 0 : config.WITH_CREDENTIALS) !== null && _c !== void 0 ? _c : false,
            CREDENTIALS: (_d = config === null || config === void 0 ? void 0 : config.CREDENTIALS) !== null && _d !== void 0 ? _d : 'include',
            TOKEN: config === null || config === void 0 ? void 0 : config.TOKEN,
            USERNAME: config === null || config === void 0 ? void 0 : config.USERNAME,
            PASSWORD: config === null || config === void 0 ? void 0 : config.PASSWORD,
            HEADERS: config === null || config === void 0 ? void 0 : config.HEADERS,
            ENCODE_PATH: config === null || config === void 0 ? void 0 : config.ENCODE_PATH,
        }, this.interceptor);
        this.aiConversations = new AiConversationsService(this.request);
        this.apiKeys = new ApiKeysService(this.request);
        this.apiMonitoring = new ApiMonitoringService(this.request);
        this.branches = new BranchesService(this.request);
        this.codeCompletions = new CodeCompletionsService(this.request);
        this.credentials = new CredentialsService(this.request);
        this.deviceLogin = new DeviceLoginService(this.request);
        this.entitlements = new EntitlementsService(this.request);
        this.environmentVariables = new EnvironmentVariablesService(this.request);
        this.feedback = new FeedbackService(this.request);
        this.git = new GitService(this.request);
        this.health = new HealthService(this.request);
        this.homepage = new HomepageService(this.request);
        this.identities = new IdentitiesService(this.request);
        this.identityDomains = new IdentityDomainsService(this.request);
        this.identityProviders = new IdentityProvidersService(this.request);
        this.invites = new InvitesService(this.request);
        this.linkChecks = new LinkChecksService(this.request);
        this.memberships = new MembershipsService(this.request);
        this.nomadEvents = new NomadEventsService(this.request);
        this.organizations = new OrganizationsService(this.request);
        this.organizationSlugs = new OrganizationSlugsService(this.request);
        this.projectAnalytics = new ProjectAnalyticsService(this.request);
        this.projectBuilds = new ProjectBuildsService(this.request);
        this.projectCustomDomains = new ProjectCustomDomainsService(this.request);
        this.projectDeploys = new ProjectDeploysService(this.request);
        this.projects = new ProjectsService(this.request);
        this.projectSlugs = new ProjectSlugsService(this.request);
        this.projectSources = new ProjectSourcesService(this.request);
        this.projectTemplates = new ProjectTemplatesService(this.request);
        this.pullRequests = new PullRequestsService(this.request);
        this.pushes = new PushesService(this.request);
        this.queues = new QueuesService(this.request);
        this.rbac = new RbacService(this.request);
        this.registry = new RegistryService(this.request);
        this.remotes = new RemotesService(this.request);
        this.scorecards = new ScorecardsService(this.request);
        this.scout = new ScoutService(this.request);
        this.seats = new SeatsService(this.request);
        this.session = new SessionService(this.request);
        this.slack = new SlackService(this.request);
        this.subscription = new SubscriptionService(this.request);
        this.support = new SupportService(this.request);
        this.syncer = new SyncerService(this.request);
        this.teams = new TeamsService(this.request);
        this.userInvites = new UserInvitesService(this.request);
        this.users = new UsersService(this.request);
        this.wysiwyg = new WysiwygService(this.request);
    }
}
//# sourceMappingURL=Client.js.map